import React from 'react';
import Close from "../Button/Close";
var defaultProps = {
  className: '',
  removable: true,
  maxWidth: 14
};

var LabelBadge = function LabelBadge(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? defaultProps.className : _ref$className,
      label = _ref.label,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? defaultProps.maxWidth : _ref$maxWidth,
      onRemove = _ref.onRemove,
      _ref$removable = _ref.removable,
      removable = _ref$removable === void 0 ? defaultProps.removable : _ref$removable,
      value = _ref.value;
  var labelClasses = 'bg-light text-muted rounded-start d-inline-flex align-self-center h-100 px-3 py-2';
  var valueClasses = 'label-badge-value text-truncate rounded-end px-3 py-2';
  var style = {
    maxWidth: maxWidth ? "".concat(maxWidth, "rem") : ''
  };
  return /*#__PURE__*/React.createElement("span", {
    className: "border rounded d-inline-flex flex-row justify-content-between align-items-center ".concat(className)
  }, label && /*#__PURE__*/React.createElement("strong", {
    className: labelClasses,
    style: style
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-truncate"
  }, label)), /*#__PURE__*/React.createElement("span", {
    className: valueClasses,
    style: style
  }, value), removable && /*#__PURE__*/React.createElement(Close, {
    className: "me-2",
    onClick: onRemove
  }));
};

LabelBadge.displayName = "LabelBadge";
export default LabelBadge;